export default "__VITE_ASSET__BZEsTC1y__"